import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Reconoce cualquier variante del formato de reseña: "Análisis de disco",
// "Análisis Disco", sin acentos, etc.
export function isAlbumReviewFormat(format) {
  const f = (format || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  return f.includes("analisis") && f.includes("disco");
}
